// Entry point for the build script in your package.json
import { bootstrap } from '@tabler/core' // Tabler theme. It includes Bootstrap
import '@hotwired/turbo-rails'
import './controllers'
import '@rails/actiontext'
import '@37signals/lexxy'

// @tabler/core bundles its own compiled copy of Bootstrap (and self-wires
// every [data-bs-toggle] on import, just above). Stimulus controllers that
// need a Modal/Tooltip class must reuse *this* copy instead of importing the
// plain 'bootstrap' npm package: two independent copies both listening on the
// same data-bs-toggle attributes double-handle every click (each one
// opens/closes in turn, net effect: nothing happens) -- that breaks every
// dropdown, collapse and modal. window.bootstrap is the hand-off point.
window.bootstrap = bootstrap
